import { RouterLink } from "../../../../../../../components/router-link";

interface Props {
  audiologistId: string;
  label: string;
}

export const AudiologistDetailLinkCell = ({ audiologistId, label }: Props) => {
  return (
    <RouterLink params={{ audiologistId }} to={"/app/audiologists/$audiologistId"} underline="hover">
      {label}
    </RouterLink>
  );
};
